module.exports = __webpack_public_path__ + "img/xiyiji.6dc8f668.svg";